//ViewItems.js
import React, { Component } from 'react';
import axios from 'axios';
import {
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  TextField,
  Button, Tooltip,
  TablePagination,
} from '@mui/material';
import { Checkbox } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from '@mui/icons-material/Close';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import { Navigate } from 'react-router-dom';
import Serverurl from './Apiurl';
import { useLocation } from "react-router-dom";
import { Snackbar, Alert } from "@mui/material";
import { NavLink } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import BusinessIcon from '@mui/icons-material/Business';
function withRouter(Component) {
  return function Wrapper(props) {
    const location = useLocation();
    return <Component {...props} location={location} />;
  };
}
class ViewItems extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],categories: [],
	  customers: {},
selectedCategory: null,
      page: 0,
      rowsPerPage: 12,
      itemsPerPageOptions: [12, 24, 48],
      totalItems: 0,
snackbarOpen: false,
  snackbarMessage: "",
  snackbarSeverity: "success", 
      selectedItems: [],
      assignDialogOpen: false,
      serviceProviders: [],
      selectedServiceProvider: '',
      shareDialogOpen: false,
      shareEmailList: '',
      modalData: null,
      showModal: false,
	 imageDialogOpen: false,
	selectedImage: null,
    };
  }
  componentDidMount() {
    document.title = "Prep for Sale - Customer Items";
    if (localStorage.getItem("DCuserid") == null) {
      this.setState({
        logredirect: true,
        pagename: '/'
      });
      return;
    }
this.fetchCategories();
    this.loadItems();
	const customer = this.props.location.state?.customer;
	console.log("Customer received:", customer);
	if (customer) {
	  this.setState({ customer });
	} 
  }
fetchCategories = () => {
  axios
    .get(`${Serverurl}categories/categoriesgetall`)
    .then((res) => {
      this.setState({ categories: res.data });
    });
};
handleCategoryClick = (catId) => {
  const selectedCategory = catId === 'all' ? null : Number(catId);
  this.setState({ selectedCategory, page: 0 }, this.loadItems);
};
 loadItems = () => {
const query = new URLSearchParams(this.props.location.search);
const customerId = query.get("id");
  const { page, rowsPerPage } = this.state;
axios.get(`${Serverurl}items/itemmanagementgetall`, {
  params: {
    customerId,
    page,
    limit: rowsPerPage,
    categoryId: this.state.selectedCategory || ""
  }
})
  .then((res) => {
    const { data, totalItems } = res.data;
    this.setState({
      items: data,
      totalItems,
      selectedItems: [],
    });
  });
};
  toggleSelectItem = (id) => {
    const { selectedItems } = this.state;
    this.setState({
      selectedItems: selectedItems.includes(id)
        ? selectedItems.filter(i => i !== id)
        : [...selectedItems, id],
    });
  };
handleImageClick = (image) => {
  this.setState({
    selectedImage: image,
    imageDialogOpen: true,
  });
};
  handleInfoClick = (item) => {
    this.setState({ modalData: item, showModal: true });
  };
  openAssignDialog = () => {
    axios
      .get(Serverurl + 'serviceprovider/all')
      .then(res =>
        this.setState({ serviceProviders: res.data, assignDialogOpen: true })
      );
  };
  handleAssign = () => {
    if (!this.state.selectedServiceProvider) {
this.showSnackbar("Please select a service provider", "warning");
      return;
    }
    axios
      .put(Serverurl + 'items/assign', {
        itemIds: this.state.selectedItems,
        serviceProviderId: this.state.selectedServiceProvider,
      })
      .then((res) => {
        this.showSnackbar(res.data.message);
        this.setState({
          assignDialogOpen: false,
          selectedServiceProvider: '',
          selectedItems: [],
        });
        this.loadItems();
      });
  };
  openShareDialog = () => {
    if (this.state.selectedItems.length === 0) {
      this.showSnackbar('Please select at least one item to share.');
      return;
    }
    this.setState({ shareDialogOpen: true });
  };
  handleShareItems = () => {
    if (!this.state.shareEmailList.trim()) {
      this.showSnackbar('Please enter at least one email address.');
      return;
    }
    const emails = this.state.shareEmailList
      .split(',')
      .map(e => e.trim())
      .filter(Boolean);
 axios.post(Serverurl + 'items/itemmanagement/share', {
    itemIds: this.state.selectedItems,
    emails: emails
})
      .then((res) => {
        this.showSnackbar(res.data.message);
        this.setState({
          shareDialogOpen: false,
          shareEmailList: '',
          selectedItems: [],
        });
      });
  };
  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage }, this.loadItems);
  };
  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: parseInt(event.target.value, 10), page: 0 }, this.loadItems);
  };
showSnackbar = (message, severity = "success") => {
  this.setState({
    snackbarOpen: true,
    snackbarMessage: message,
    snackbarSeverity: severity,
  });
};
  render() {
    if (this.state.logredirect === true) {
      return <Navigate to={this.state.pagename} />;
    }
    const { items, modalData } = this.state;
    return (
      <Box>
        <div className="maincontentDiv">
         <Box 
  sx={{ 
    display: 'flex', 
    justifyContent: 'space-between', 
    alignItems: 'center',
    mb: 2 
  }}
>
  <Typography pt={2} className="contentHeading" variant="h5">
    Item Management
  </Typography>
  <NavLink to="/ItemManagement">
    <Button
      style={{
        marginRight: "20px",
        marginTop: "15px"
      }}
      size="small"
      className="frmPrimarybtn"
      variant="contained"
      startIcon={<ArrowBackIcon />}
    >
      Back
    </Button>
  </NavLink>
</Box>
    <div className="customerDetails">
			<Box sx={{display: "flex",alignItems: "center",gap: 1,mt:'20px'}}>
			  <PersonIcon fontSize="small" />
			<Typography variant="body1" > {this.state.customer?.cu_name}</Typography>
			</Box>
			<Box sx={{display: "flex",alignItems: "center",gap: 1}}>
  <EmailIcon fontSize="small" />
  <a
    href={`mailto:${this.state.customer?.cu_emailid}`}
    style={{
      textDecoration: "none",
      color: "#4F5058"
    }}
  >
    <Typography variant="body1"  style={{
      textDecoration: "none",
      color: "#4F5058"
    }}>
      {this.state.customer?.cu_emailid}
    </Typography>
  </a>
</Box>
			<Box sx={{display: "flex",alignItems: "center",gap: 1}}>
  <PhoneIcon fontSize="small" />
  <a
    href={`tel:${this.state.customer?.cu_phonenumber}`}
    style={{
      textDecoration: "none",
      color: "#4F5058"
    }}
  >
    <Typography variant="body1" style={{
      textDecoration: "none",
      color: "#4F5058"
    }}>
      {this.state.customer?.cu_phonenumber}
    </Typography>
  </a>
</Box>
</div>
		   <Box className="contentHeading" mb={2}>
          <ul
            style={{
              display: 'flex',
              listStyle: 'none',
              padding: 0,
              gap: '20px',
            }}
          >
            <li
              style={{
				  backgroundColor:'#f3f7fa',
                cursor: 'pointer',
                fontWeight: !this.state.selectedCategory ? 'bold' : 'normal',
              }}
              onClick={() => this.handleCategoryClick('all')}
            >
              All
            </li>
            {this.state.categories.map(cat => (
              <li
                key={cat.cat_id}
                onClick={() => this.handleCategoryClick(cat.cat_id)}
                style={{
                  cursor: 'pointer',
                  fontWeight: this.state.selectedCategory === cat.cat_id ? 'bold' : 'normal',
                }}
              >
                {cat.cat_name}
              </li>
            ))}
          </ul>
        </Box>
<Snackbar
  open={this.state.snackbarOpen}
  autoHideDuration={10000}
  onClose={() => this.setState({ snackbarOpen: false })}
  anchorOrigin={{ vertical: "top", horizontal: "center" }}
>
  <Alert
    onClose={() => this.setState({ snackbarOpen: false })}
    severity={this.state.snackbarSeverity}
    sx={{ width: "100%" }}
  >
    {this.state.snackbarMessage}
  </Alert>
</Snackbar>
          <Box pr={3} mb={1} display="flex" justifyContent="flex-end">
            {this.state.selectedItems.length > 0 && (
              <Box display="flex" gap={2}>
                <Button style={{backgroundColor:"transparent", color:"grey"}} variant="contained" onClick={this.openShareDialog}>
                  Share via Email
                </Button>
                <Button
				size="small"
                  className="frmPrimarybtn"
                  variant="contained"
                  onClick={this.openAssignDialog}
                >
                  Assign
                </Button>
              </Box>
            )}
          </Box>
        <Box pl={5}>
  {items.length === 0 ? (
    <Typography
      variant="subtitle1"
      sx={{ mt: 3, textAlign: "center", width: "100%" }}
    >
      No items
    </Typography>
  ) : (
    <ul
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        listStyle: 'none',
        padding: 0,
        gap: '30px',
      }}
    >
      {items.map(item => (
        <li key={item.it_id} style={{ marginTop:35,width: '250px', position: 'relative' }}>
          <Box position="relative" width="210px" height="210px">
            <Box position="absolute" zIndex={2}>
              <Checkbox
                size="small"
                checked={this.state.selectedItems.includes(item.it_id)}
                onChange={() => this.toggleSelectItem(item.it_id)}
                sx={{
                  color: "#87be46",
                  '&.Mui-checked': {
                    color: "#87be46",
                  },
                  borderRadius: "5px",
                }}
              />
            </Box>
			{Array.isArray(item.it_sp_id) && item.it_sp_id.length > 0 && (
              <Box position="absolute" top={8} right={8} zIndex={2}>
                <AssignmentTurnedInIcon color="success" />
              </Box>
            )}
				<img
				  src={`${Serverurl}uploads/${item.it_image}`}
				  alt={item.it_title}
				  onClick={() => this.handleImageClick(item.it_image)}
				  style={{
					width: "210px",
					height: "210px",
					borderRadius: 10,
					objectFit: "cover",
					cursor: "pointer"
				  }}
				/>
            {item.categoryInfo?.[0]?.cat_name && (
              <Box
                position="absolute"
                bottom={8}
                left={8}
                bgcolor="#87be46"
                color="white"
                pt="4px"
                pr="10px"
                pb="4px"
                pl="10px"
                borderRadius="11px"
                fontSize="14px"
                fontWeight="500"
                zIndex={2}
                maxWidth="80%"
                overflow="hidden"
                textOverflow="ellipsis"
                whiteSpace="nowrap"
              >
                {item.categoryInfo[0].cat_name}
              </Box>
            )}
 <Box position="absolute" top={-30} right={-5} zIndex={2}>
  <Tooltip title="Information" arrow>
    <IconButton
      size="small"
      onClick={() => this.handleInfoClick(item)}
      sx={{
        backgroundColor: "rgba(255,255,255,0.9)",
        color: "#87BE46",
        width: 28,
        height: 28,
        "&:hover": {
          backgroundColor: "#fff",
        },
      }}
    >
      <InfoIcon fontSize="small" />
    </IconButton>
  </Tooltip>
</Box>
          </Box>
{/*
          <Box mt={1}>
            <Typography variant="subtitle1" noWrap>
              {item.it_title}
            </Typography>
          </Box>
*/}
        </li>
      ))}
    </ul>
  )}
</Box>
          <Dialog open={this.state.showModal} onClose={() => this.setState({ showModal: false })}  maxWidth="xs"
  fullWidth
  >
            <DialogTitle>
              Item
              <IconButton onClick={() => this.setState({ showModal: false })} style={{ float: 'right' }}>
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              {modalData?.it_image && (
                <Box mt={2}>
                 <img
  src={`${Serverurl}uploads/${modalData.it_image}`}
  alt={modalData.it_title}
  style={{
    width: "220px",
    maxWidth: "100%",
    objectFit: "contain",
    display: "block",
    margin: "0 auto"
  }}
/>
                </Box>
              )}
             <Typography variant="body1" mt={2} fontWeight="bold">
  {modalData?.it_title || ""}
</Typography>

<Typography variant="body2" sx={{ mt: 1 }}>
  {modalData?.it_notes || ""}
</Typography>

<Typography variant="body2" sx={{ mt: 2 }}>
  {" "}
  {modalData?.it_createddate
    ? new Date(modalData.it_createddate).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : "-"}
</Typography>

{modalData?.spInfo?.length > 0 ? (
  <>
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 2 }}>
      <BusinessIcon fontSize="small" color="action" />
      <Typography variant="body2">
        {modalData.spInfo[0].sp_name}
      </Typography>
    </Box>

    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
      <PhoneIcon fontSize="small" color="action" />
      <Typography variant="body2">
        {modalData.spInfo[0].sp_phonenumber}
      </Typography>
    </Box>
  </>
) : (
  <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 2 }}>
    <BusinessIcon fontSize="small" color="disabled" />
    <Typography
      variant="body2"
      sx={{ color: "text.secondary", }}
    >
      Not assigned
    </Typography>
  </Box>
)}
            </DialogContent>
          </Dialog>
			<Dialog
			  open={this.state.imageDialogOpen}
			  onClose={() => this.setState({ imageDialogOpen: false })}
			  maxWidth="md"
			>
			  <DialogTitle>
				Item
				<IconButton
				  onClick={() => this.setState({ imageDialogOpen: false })}
				  style={{ float: 'right' }}
				>
				  <CloseIcon />
				</IconButton>
			  </DialogTitle>
			  <DialogContent>
				{this.state.selectedImage && (
				  <img
					src={`${Serverurl}uploads/${this.state.selectedImage}`}
					alt="image"
					style={{width:"100%",borderRadius: 4,objectFit: "contain",}}
				  />
				)}
			  </DialogContent>
			</Dialog>
          <Dialog
  open={this.state.assignDialogOpen}
  onClose={() => this.setState({ assignDialogOpen: false })}
>
  <DialogTitle>
    Assign
    <IconButton
      onClick={() => this.setState({ assignDialogOpen: false })}
      sx={{ position: "absolute", right: 8, top: 8 }}
    >
      <CloseIcon />
    </IconButton>
  </DialogTitle>
            <DialogContent>
              <TextField
			  sx={{mt:2}}
			  size="small"
                select
                fullWidth
                SelectProps={{ native: true }}
                value={this.state.selectedServiceProvider}
                onChange={(e) => this.setState({ selectedServiceProvider: e.target.value })}
              >
                <option value="">Select</option>
                {this.state.serviceProviders.map(sp => (
                  <option key={sp.sp_id} value={sp.sp_id}>
                    {sp.sp_name}
                  </option>
                ))}
              </TextField>
              <Button
                className="frmPrimarybtn"
                variant="contained"
                sx={{ mt: 2 }}
                onClick={this.handleAssign}
              >
                Save
              </Button>
            </DialogContent>
          </Dialog>
        <Dialog
  open={this.state.shareDialogOpen}
  onClose={() => this.setState({ shareDialogOpen: false })}
>
  <DialogTitle>
    Share Items
    <IconButton
      onClick={() => this.setState({ shareDialogOpen: false })}
      sx={{ position: "absolute", right: 8, top: 8 }}
    >
      <CloseIcon />
    </IconButton>
  </DialogTitle>
            <DialogContent>
              <TextField
			  size="small"
                fullWidth
                value={this.state.shareEmailList}
                onChange={(e) => this.setState({ shareEmailList: e.target.value })}
                placeholder="example@mail.com"
                multiline
				sx={{mt:2}}
              />
			  <Typography
  variant="caption"
  color="#4F5058"
  sx={{ display: "block", mt: 1 }}
>
  <strong>Note:</strong> Enter one or more email addresses separated by commas.
</Typography>
              <Button
			  size="small"
			  className="frmPrimarybtn"
                variant="contained"
                sx={{ mt: 2 }}
                onClick={this.handleShareItems}
              >
                Share via mail
              </Button>
            </DialogContent>
          </Dialog>
          <Box display="flex" justifyContent="flex-end" mt={4}>
            <TablePagination
              component="div"
              count={this.state.totalItems}
              page={this.state.page}
              onPageChange={this.handleChangePage}
              rowsPerPage={this.state.rowsPerPage}
              onRowsPerPageChange={this.handleChangeRowsPerPage}
              rowsPerPageOptions={this.state.itemsPerPageOptions}
            />
          </Box>
        </div>
      </Box>
    );
  }
}
export default withRouter(ViewItems);